const hostname = location.hostname

export function getAuthConfig() {
  let authConfig
  if (hostname.includes('dev') || hostname.includes('localhost')) {
    authConfig = {
      domain: import.meta.env.VITE_AUTH0_DOMAIN,
      clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE
    }
  } else if (hostname.includes('testlab')) {
    authConfig = {
      domain: import.meta.env.VITE_AUTH0_DOMAIN_TESTLAB,
      clientId: import.meta.env.VITE_AUTH0_CLIENT_ID_TESTLAB,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE_TESTLAB
    }
  } else {
    authConfig = {
      domain: import.meta.env.VITE_AUTH0_DOMAIN_PRODUCTION,
      clientId: import.meta.env.VITE_AUTH0_CLIENT_ID_PRODUCTION,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE_PRODUCTION
    }
  }

  return authConfig
}

export function getBaseURL() {
  let baseUrl
  if (hostname.includes('dev') || hostname.includes('localhost')) {
    baseUrl = import.meta.env.VITE_BASE_URL
  } else if (hostname.includes('testlab')) {
    baseUrl = import.meta.env.VITE_BASE_URL_TESTLAB
  } else {
    baseUrl = import.meta.env.VITE_BASE_URL_PRODUCTION
  }

  return baseUrl
}

export function getRedirectDomain() {
  let redirectDomain
  if (hostname.includes('dev') || hostname.includes('localhost')) {
    redirectDomain = import.meta.env.VITE_PORTAL_REDIRECT_BASE_URL
  } else if (hostname.includes('testlab')) {
    redirectDomain = import.meta.env.VITE_PORTAL_REDIRECT_BASE_URL_TESTLAB
  } else {
    redirectDomain = import.meta.env.VITE_PORTAL_REDIRECT_BASE_URL_PRODUCTION
  }

  return redirectDomain
}

export function getDomainCookie() {
  let domainCookie
  if (hostname.includes('dev')) {
    domainCookie = import.meta.env.VITE_PORTAL_DOMAIN_COOKIE
  } else if (hostname.includes('localhost')) {
    domainCookie = import.meta.env.VITE_PORTAL_DOMAIN_COOKIE_LOCAL
  } else if (hostname.includes('testlab')) {
    domainCookie = import.meta.env.VITE_PORTAL_DOMAIN_COOKIE_TESTLAB
  } else {
    domainCookie = import.meta.env.VITE_PORTAL_DOMAIN_COOKIE_PRODUCTION
  }

  return domainCookie
}
